import React from 'react'
import { useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import TextFieldUniversal from '../../../../validate/form/text/TextFieldUniversal'
import { setSuppliersQuery } from '../../../../../store/supplierSlice'

const SuppliersFilterQuery = () => {

    const query = useSelector(state => state.supplier.suppliers.query)
    const dispatch = useDispatch()

    const [value, setValue] = useState('')

  return (
    <TextFieldUniversal
        value={value}
        setValue={e => {
            // setValueForm(e)
            dispatch(setSuppliersQuery(e))
            setValue(e)
        }}
        // setValidate={setValidate}
        label={'Пошук'} 
        placeholder={'Введіть для пошуку'}
        validates={{
            isEmpty: true,
        }}
        forciblyValue={query}
        required={false}		
    />
  )
}

export default SuppliersFilterQuery